import { Perfil } from './perfil';
import {Idioma} from "./idioma";
import { Dictionary } from "../utils/_index";

export class User {
    id_usuario: number;
    nombre_usuario: string;
    contraseña: string;
    nombre: string;
    apellido: string;
    email: string;
    id_moneda: number;
    id_cultura: number;
    locale: string;
    id_cliente: number;
    perfil: Perfil = new Perfil();
    diccAcciones: any;
    idioma: Idioma;
    variablesLocales: any; //{"5":{"idVariableLocal":5,"valor":"2","nombreDes":{"id":-1,"traducciones":{}}}};
    activo : boolean;
    fecha_caducidad: Date;
}
